// HEADER MENU HOVER START

jQuery(document).ready(function ($) {
  $(".mega-menu").each(function () {
    const $details = $(this);
    const $summary = $details.find("summary");

    // Open on hover
    $details.on("mouseenter", function () {
      $details.attr("open", true);
      $summary.attr("aria-expanded", "true");
    });

    // Close when mouse leaves
    $details.on("mouseleave", function () {
      $details.removeAttr("open");
      $summary.attr("aria-expanded", "false");
    });

    // Prevent click from toggling (optional)
    $summary.on("click", function (e) {
      e.preventDefault();
    });
  });
// HEADER MENU HOVER END


  // ABOUT PAGE COUNTER JS START
  if ($('.counter_col').length >0) {
  function startCounter() {
    $('.counter').each(function () {
      var $this = $(this);
      var target = parseInt($this.attr('data-target'));
      var hasPlus = $this.text().trim().includes('+'); // check if original text had '+'
      var current = 0;
      var duration = 2000; // total animation time
      var stepTime = 20;
      var steps = duration / stepTime;
      var increment = Math.ceil(target / steps);

      var counterInterval = setInterval(function () {
        current += increment;
        if (current >= target) {
          current = target;
          clearInterval(counterInterval);
        }
        $this.text(current + (hasPlus ? '+' : ''));
      }, stepTime);
    });
  }

  // Trigger counter when section visible
  var counterStarted = false;
  $(window).on('scroll', function () {
    var sectionTop = $('.counter_col').offset().top;
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();

    if (!counterStarted && scrollTop + windowHeight > sectionTop + 100) {
      startCounter();
      counterStarted = true;
    }
  });
  }
  // ABOUT PAGE COUNTER JS END


  // LOGIN PAGE FORGOT YOUR PASSWORD CLICK JS START

  // On page load — check if hash is #recover
  if (window.location.hash === "#recover") {
    $(".customer_login_title_form").addClass("hide");
    $(".reset_your_password_wrap").addClass("active");
  } else {
    $(".customer_login_title_form").removeClass("hide");
    $(".reset_your_password_wrap").removeClass("active");
  }

  // Forgot Password click
  $(".forgot_your_password").on("click", function (e) {
    e.preventDefault();
    window.location.hash = "recover"; // set hash manually
    $(".customer_login_title_form").addClass("hide");
    $(".reset_your_password_wrap").addClass("active");
  });

  // Cancel click
  $(".reset_your_password_cancel").on("click", function (e) {
    e.preventDefault();
    window.location.hash = "login"; // set hash manually
    $(".customer_login_title_form").removeClass("hide");
    $(".reset_your_password_wrap").removeClass("active");
  });


// On page load — check if hash is #recover
if (window.location.hash === "#recover") {
  $(".customer_login_title_form").addClass("hide");
  $(".reset_your_password_wrap").addClass("active");
} else {
  $(".customer_login_title_form").removeClass("hide");
  $(".reset_your_password_wrap").removeClass("active");
}

// Forgot Password click
$(".forgot_your_password").on("click", function (e) {
  e.preventDefault();
  window.location.hash = "recover"; // set hash manually
  $(".customer_login_title_form").addClass("hide");
  $(".reset_your_password_wrap").addClass("active");
});

// Cancel click
$(".reset_your_password_cancel").on("click", function (e) {
  e.preventDefault();
  window.location.hash = "login"; // set hash manually
  $(".customer_login_title_form").removeClass("hide");
  $(".reset_your_password_wrap").removeClass("active");
});

// LOGIN PAGE FORGOT YOUR PASSWORD CLICK JS END


// PRODUCT PAGE (COLLECTION) GRID VIEW START

var $main = $('.product_filter_main');
var $titles = $('.product_card_content_wrap .card__information h3');

let $desk_cols = $main.attr("data-desktop-cols");
let $tab_cols = $main.attr("data-tab-cols");
let $mob_cols = $main.attr("data-mobile-cols");

// Function to update title class based on grid layout
function updateTitleClass() {
  if ($main.hasClass('product_grid_view1')) {
    $titles.addClass('h4').removeClass('h6');
  } else {
    $titles.removeClass('h4').addClass('h6');
  }
}

// Function to set default grid view based on screen size
function setDefaultGridView() {
  var windowWidth = $(window).width();
  $main.removeClass('product_grid_view1 product_grid_view2 product_grid_view3');

  if (windowWidth <= 767) {
    $main.addClass($mob_cols);
  } else if (windowWidth < 1200) {
    $main.addClass($tab_cols);
  } else {
    $main.addClass($desk_cols);
  }

  updateTitleClass();
}

// Set default on page load
setDefaultGridView();

// Manual clicks override the current layout
$(document).on('click','.grid_view1_icon', function() {
  $main.removeClass('product_grid_view2 product_grid_view3')
       .addClass('product_grid_view1');

         // Save user preference
  localStorage.setItem('product_grid_view', 'product_grid_view1');

  updateTitleClass();
});

$(document).on('click', '.grid_view2_icon', function() {
  $main.removeClass('product_grid_view1 product_grid_view3')
       .addClass('product_grid_view2');
       localStorage.setItem('product_grid_view', 'product_grid_view2');
  updateTitleClass();
});

$(document).on('click','.grid_view3_icon', function() {
  $main.removeClass('product_grid_view1 product_grid_view2')
       .addClass('product_grid_view3');
       localStorage.setItem('product_grid_view', 'product_grid_view3');
  updateTitleClass();
});

// PRODUCT PAGE (COLLECTION) GRID VIEW END


// -----------------------------------------------------


// BLOG (ARTICLE) BLOCKQUOTE ADD DIV AND CLASS START
  $('.content_wrapper blockquote').each(function () {
    if (!$(this).find('.blockquote_content').length) {
      var content = $(this).html();
      $(this).html('<div class="blockquote_content">' + content + '</div>');
    }
  });
// BLOG (ARTICLE) BLOCKQUOTE ADD DIV AND CLASS END



// CART PAGE DIV WRAPPER JQUERY START
 var $items = $('.custom-cart-items');
    var $footer = $('.custom-cart-footer');

    // Check both elements exist
    if ($items.length && $footer.length) {
        // Create wrapper div
        var $wrapper = $('<div class="custom_cart_items_footer_wrap comm-space page-width"></div>');

        // Insert wrapper before .custom-cart-items
        $wrapper.insertBefore($items);

        // Move both items into wrapper
        $wrapper.append($items);
        $wrapper.append($footer);
    }
// CART PAGE DIV WRAPPER JQUERY END


});



// HOME VIDEO SLIDER START

if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

let ytPlayers = {}; // keyed by iframe id
let apiReady = false;
let mainSwiper = null;
let thumbsSwiper = null;

const YTPlayerState = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
};

function onYouTubeIframeAPIReady() {
  apiReady = true;
  if (mainSwiper) {
    setTimeout(() => {
      createAllYouTubePlayers();
    }, 300);
  }
}

window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

function getVideoSection() {
  return document.querySelector('.video_slider_section');
}

function getAllMainIframes() {
  return document.querySelectorAll('.swiper-main .yt_video iframe');
}

function getAllThumbnails() {
  return document.querySelectorAll('.swiper-main .yt_video .thumbnail');
}

function showAllThumbnails() {
  getAllThumbnails().forEach(thumb => {
    thumb.style.visibility = 'visible';
    thumb.style.opacity = '1';
    thumb.style.pointerEvents = 'auto';
  });
}

function hideAllThumbnails() {
  getAllThumbnails().forEach(thumb => {
    thumb.style.visibility = 'hidden';
    thumb.style.opacity = '0';
    thumb.style.pointerEvents = 'none';
  });
}

function ensureIframeId(iframe, index) {
  if (!iframe.id) {
    iframe.id = `yt-video-auto-${index}`;
  }
  return iframe.id;
}

function createAllYouTubePlayers() {
  if (!apiReady) return false;

  const allIframes = getAllMainIframes();
  if (!allIframes.length) return false;

  allIframes.forEach((iframe, index) => {
    const iframeId = ensureIframeId(iframe, index);

    if (ytPlayers[iframeId]) return;

    if (iframe.src.indexOf('enablejsapi=') === -1) {
      iframe.src += (iframe.src.indexOf('?') === -1 ? '?' : '&') + 'enablejsapi=1';
    }

    if (iframe.src.indexOf('origin=') === -1) {
      iframe.src += (iframe.src.indexOf('?') === -1 ? '?' : '&') + 'origin=' + encodeURIComponent(window.location.origin);
    }

    iframe.loading = 'eager';

    try {
      ytPlayers[iframeId] = new YT.Player(iframe, {
        events: {
          onStateChange: function (event) {
            onPlayerStateChange(event, iframeId);
          }
        }
      });
    } catch (error) {
      console.error('Error creating YouTube player for iframe:', iframeId, error);
    }
  });

  return true;
}

function onPlayerStateChange(event, iframeId) {
  const section = getVideoSection();
  if (!section || !mainSwiper) return;

  const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
  const activeIframe = activeSlide ? activeSlide.querySelector('.yt_video iframe') : null;
  const activeIframeId = activeIframe ? activeIframe.id : null;

  if (event.data === YTPlayerState.PLAYING) {
    hideAllThumbnails();
    section.classList.add('video_start');
  }

  if (
    (event.data === YTPlayerState.PAUSED || event.data === YTPlayerState.ENDED) &&
    iframeId === activeIframeId
  ) {
    section.classList.remove('video_start');
    syncContentWithSlide(mainSwiper);
    showAllThumbnails();
  }
}

function pauseAllYouTubeVideos() {
  Object.keys(ytPlayers).forEach(key => {
    const player = ytPlayers[key];
    if (player && typeof player.pauseVideo === 'function') {
      player.pauseVideo();
    }
  });
}

function stopAllYouTubeVideos() {
  Object.keys(ytPlayers).forEach(key => {
    const player = ytPlayers[key];
    if (player && typeof player.stopVideo === 'function') {
      player.stopVideo();
    }
  });
}

function playActiveYouTubeVideo() {
  if (!mainSwiper) return;

  const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
  if (!activeSlide) return;

  const activeIframe = activeSlide.querySelector('.yt_video iframe');
  if (!activeIframe) return;

  const iframeId = activeIframe.id;
  const player = ytPlayers[iframeId];

  pauseAllYouTubeVideos();

  if (!player) {
    setTimeout(() => {
      createAllYouTubePlayers();
      setTimeout(playActiveYouTubeVideo, 150);
    }, 150);
    return;
  }

  if (typeof player.playVideo === 'function') {
    player.playVideo();
  }
}

function resetActiveIframe() {
  if (!mainSwiper) return;

  const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
  if (!activeSlide) return;

  const iframe = activeSlide.querySelector('.yt_video iframe');
  if (!iframe) return;

  const src = iframe.getAttribute('src');
  iframe.setAttribute('src', src);

  // remove stale player instance for this iframe so it can be rebuilt
  if (iframe.id && ytPlayers[iframe.id]) {
    delete ytPlayers[iframe.id];
  }

  setTimeout(() => {
    createAllYouTubePlayers();
  }, 150);
}

function stopAllVideos(swiper) {
  const allVideos = swiper.el.querySelectorAll('video');
  allVideos.forEach(v => {
    v.pause();
    v.currentTime = 0;
  });
}

function syncContentWithSlide(swiper) {
  const allContents = document.querySelectorAll('.video_slider_content_item');
  allContents.forEach(item => item.classList.remove('active'));

  const realIndex = swiper.realIndex;
  const activeItem = allContents[realIndex];
  if (activeItem) activeItem.classList.add('active');
}

if (document.querySelector('.video_slider_section')) {
  const realSlides = document.querySelectorAll('.swiper-thumb .swiper-slide').length || 3;

  thumbsSwiper = new Swiper('.swiper-thumb', {
    loop: false,
    spaceBetween: 30,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper1-button-next',
      prevEl: '.swiper1-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      400: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });

  mainSwiper = new Swiper('.swiper-main', {
    loop: true,
    loopedSlides: realSlides,
    spaceBetween: 0,
    thumbs: { swiper: thumbsSwiper },
    on: {
      init() {
        syncContentWithSlide(this);
        setTimeout(() => {
          createAllYouTubePlayers();
        }, 500);
      },
      slideChangeTransitionEnd() {
        const section = getVideoSection();
        pauseAllYouTubeVideos();
        if (section) section.classList.remove('video_start');
        syncContentWithSlide(this);
        showAllThumbnails();
      },
    },
  });

  const playBtn = document.querySelector('.video_slider_play_icon');
  if (playBtn) {
    playBtn.addEventListener('click', () => {
      const section = getVideoSection();
      if (!section || !mainSwiper) return;

      section.classList.add('video_start');

      const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
      const video = activeSlide ? activeSlide.querySelector('video') : null;
      const isYouTubeSlide = activeSlide ? activeSlide.querySelector('.yt_video iframe') : null;

      if (isYouTubeSlide) {
        stopAllVideos(mainSwiper);
        playActiveYouTubeVideo();
      } else if (video) {
        pauseAllYouTubeVideos();
        video.play().catch((e) => console.error('Video play error:', e));
      }

      syncContentWithSlide(mainSwiper);
    });
  }

  document.querySelectorAll('.swiper1-button-prev').forEach(btn => {
    btn.addEventListener('click', () => {
      pauseAllYouTubeVideos();
      const section = getVideoSection();
      if (section) section.classList.remove('video_start');
      showAllThumbnails();
      thumbsSwiper.slidePrev();
      mainSwiper.slidePrev();
    });
  });

  document.querySelectorAll('.swiper1-button-next').forEach(btn => {
    btn.addEventListener('click', () => {
      pauseAllYouTubeVideos();
      const section = getVideoSection();
      if (section) section.classList.remove('video_start');
      showAllThumbnails();
      thumbsSwiper.slideNext();
      mainSwiper.slideNext();
    });
  });

  document.querySelectorAll('.video-close-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const section = getVideoSection();
      if (!section || !mainSwiper) return;

      stopAllYouTubeVideos();
      resetActiveIframe();
      section.classList.remove('video_start');
      syncContentWithSlide(mainSwiper);
      showAllThumbnails();
    });
  });
}

// HOME VIDEO SLIDER END

// HOME SHOP NEW ARRIVALS SLIDER START

const swiper = new Swiper('.featured_collection_with_slider .featured_collection_with_slider_wrap', {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 30,
    pagination: {
      el: '.slider__pagination',
      clickable: true,
    },
  //   autoplay: {
  //     delay: 3000,
  //     disableOnInteraction: true,
  // },
    breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
      1025: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1281: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
  });
// HOME SHOP NEW ARRIVALS SLIDER END

//CART PAGE COUPON DROPDOWN START
// Dropdown open/close
  $(".coupon_code_box .coupon-toggle").on("click", function () {
    const parent = $(this).closest(".coupon_code_box");
    parent.toggleClass("active");
    parent.find(".coupon-input-box").slideToggle(200);
  });
//CART PAGE COUPON DROPDOWN END


// JS for Hover Megamenu

$('.mega-menu__content ul.list-unstyled li[data-hover-img]').on('mouseenter', function () {
    const hoverImg = $(this).data('hover-img');
    const $targetImg = $('.mega-nav-image img');

    if (hoverImg && $targetImg.length) {
        $targetImg.attr('src', hoverImg);
    }
});


// // New JS for SORT
$(document).on('click', '.custom-sortby-btn', function (e) {
    e.stopPropagation();
    e.preventDefault();

    const $dropdown = $(this).closest('.custom-sortby-dropdown');
    const $optionsList = $dropdown.find('.custom-sortby-options');

    $optionsList.toggle();
    $(this).toggleClass('open');
});


$(document).on('click', '.custom-sortby-options li', function () {
    const $li = $(this);
    const value = $li.data('value');

    const $dropdown = $li.closest('.custom-sortby-dropdown');
    const $selectedText = $dropdown.find('span.selected-text');
    const $optionsList = $dropdown.find('.custom-sortby-options');
    const $btn = $dropdown.find('.custom-sortby-btn');

    // Shopify's select is NOT inside dropdown — target globally
    const $select = $('select[name="sort_by"]');

    // Update UI
    $select.val(value);
    $selectedText.text($li.text());

    $optionsList.hide();
    $btn.removeClass('open');

    $optionsList.find('li').removeClass('active');
    $li.addClass('active');

    // Trigger Shopify sorting
    const selectEl = $select[0];
    selectEl.dispatchEvent(new Event('input', { bubbles: true }));
    selectEl.dispatchEvent(new Event('change', { bubbles: true }));
});


// Close dropdown when clicking outside
$(document).on('click', function () {
    $('.custom-sortby-options').hide();
    $('.custom-sortby-btn').removeClass('open');
});
// // New JS for Sort End



/* -------------------------------
   PRICE SLIDER (FULL REWRITE)
-------------------------------- */

let sliderInitialized = false;

function initializePriceSlider() {
    if (sliderInitialized) return;

    $(".facets__price").each(function () {
        const $facet = $(this);

        const minPrice = 0;
        const maxPrice = parseInt(
            ($facet.find(".max_value_input").data("max")).replace(/,/g, "")
        ) || 10000;

        // Dynamic minGap based on price range
        const priceRange = maxPrice - minPrice;
        const minGap = Math.max(1, Math.floor(priceRange * 0.05)); // 5% of range

        // URL params
        const params = new URLSearchParams(window.location.search);
        const urlMin = parseInt(params.get("filter.v.price.gte"));
        const urlMax = parseInt(params.get("filter.v.price.lte"));

        const initialMin = !isNaN(urlMin) ? urlMin : minPrice;
        const initialMax = !isNaN(urlMax) ? urlMax : maxPrice;

        // Inputs start EMPTY
        // const $minInput = $facet.find(".min_value_input").val("");
        // const $maxInput = $facet.find(".max_value_input").val("");

        const $minInput = $facet.find(".min_value_input");
        const $maxInput = $facet.find(".max_value_input");

        // Set only if input is empty
        if (!$minInput.val()) {
            $minInput.val(!isNaN(urlMin) ? initialMin : "");
        }

        if (!$maxInput.val()) {
            $maxInput.val(!isNaN(urlMax) ? initialMax : "");
        }

        // Create slider only once
        if ($facet.find(".range-slider").length === 0) {
            const sliderHTML = `
                <div class="range-slider">
                    <div class="slider-track"></div>
                    <div class="slider-range"></div>

                    <input type="range" class="rangeMin"
                           min="${minPrice}" max="${maxPrice}"
                           value="${initialMin}" step="1">

                    <input type="range" class="rangeMax"
                           min="${minPrice}" max="${maxPrice}"
                           value="${initialMax}" step="1">

                    <div class="range-label labelMin">$${initialMin}</div>
                    <div class="range-label labelMax">$${initialMax}</div>
                </div>
            `;
            $facet.append(sliderHTML);
        }
    });

    $(".range-slider").each(function () {
        const $slider = $(this);
        const $facet = $slider.closest(".facets__price");

        const minPrice = 0;
        const maxPrice = parseInt(
            ($facet.find(".max_value_input").data("max") || "0").replace(/,/g, "")
        ) || 10000;

        const priceRange = maxPrice - minPrice;
        const minGap = Math.max(1, Math.floor(priceRange * 0.05));

        const $minRange = $slider.find(".rangeMin");
        const $maxRange = $slider.find(".rangeMax");
        const $track = $slider.find(".slider-range");

        const $labelMin = $slider.find(".labelMin");
        const $labelMax = $slider.find(".labelMax");

        const $inputMin = $facet.find(".min_value_input");
        const $inputMax = $facet.find(".max_value_input");

        function updateSlider(e, userAction = false) {
            let minVal = parseInt($minRange.val());
            let maxVal = parseInt($maxRange.val());

            if (maxVal - minVal < minGap) {
                if ($(e?.target).hasClass("rangeMin")) {
                    minVal = maxVal - minGap;
                    $minRange.val(minVal);
                } else {
                    maxVal = minVal + minGap;
                    $maxRange.val(maxVal);
                }
            }

            // Track fill positions
            const p1 = (minVal / maxPrice) * 100;
            const p2 = (maxVal / maxPrice) * 100;

            $track.css({
                left: p1 + "%",
                right: (100 - p2) + "%"
            });

            // Labels
            $labelMin.text(`$${minVal}`);
            $labelMax.text(`$${maxVal}`);

            // Position labels (delayed for correct width calc)
setTimeout(() => {
    const minLabelWidth = $labelMin.outerWidth() || 50;
    const maxLabelWidth = $labelMax.outerWidth() || 50;

    let sliderWidth = $slider.width();
    if (sliderWidth === 0) sliderWidth = $slider.parent().width() || 300;

    // Convert label width -> percentage of slider
    const minLabelPercent = (minLabelWidth / sliderWidth) * 100;
    const maxLabelPercent = (maxLabelWidth / sliderWidth) * 100;

    // Initial centered positions
    let minLabelPos = p1 - minLabelPercent / 2;
    let maxLabelPos = p2 - maxLabelPercent / 2;

    // EDGE LOCKING
    if (p1 <= minLabelPercent / 2) {
      minLabelPos = 0;
    }

    if (p2 >= 100 - maxLabelPercent / 2) {
      maxLabelPos = 100 - maxLabelPercent;
    }

    minLabelPos = Math.max(0, Math.min(minLabelPos, 100 - minLabelPercent));
    maxLabelPos = Math.max(0, Math.min(maxLabelPos, 100 - maxLabelPercent));

    const gap = 0.5;
    const minRight = minLabelPos + minLabelPercent;

    if (minRight + gap > maxLabelPos) {
      const overlap = minRight + gap - maxLabelPos;

      if (minLabelPos > 0 && maxLabelPos < 100 - maxLabelPercent) {
        minLabelPos -= overlap / 2;
        maxLabelPos += overlap / 2;
      } else if (minLabelPos === 0) {
        maxLabelPos = minLabelPos + minLabelPercent + gap + 1;
      } else {
        minLabelPos = maxLabelPos - minLabelPercent - gap - 1 ;
      }

      minLabelPos = Math.max(0, minLabelPos);
      maxLabelPos = Math.min(100 - maxLabelPercent, maxLabelPos);
    }
    

    // // Center the label around the thumb position
    // const minLabelPos = Math.max(0, Math.min(p1 - (minLabelPercent / 2), 100 - minLabelPercent));
    // const maxLabelPos = Math.max(0, Math.min(p2 - (maxLabelPercent / 2), 100 - maxLabelPercent));

    $labelMin.css("left", minLabelPos + "%");
    $labelMax.css("left", maxLabelPos + "%");
}, 10);

            // Update hidden inputs ONLY on user input
            if (userAction) {
                $inputMin.val(minVal);
                $inputMax.val(maxVal);
            }
        }

        // Events
        $minRange.on("input", e => updateSlider(e, true));
        $maxRange.on("input", e => updateSlider(e, true));

        $inputMin.on("input", function () {
            const v = parseInt($(this).val()) || minPrice;
            $minRange.val(v);
            updateSlider(null, true);
        });

        $inputMax.on("input", function () {
            const v = parseInt($(this).val()) || maxPrice;
            $maxRange.val(v);
            updateSlider(null, true);
        });

        // initial paint
        updateSlider();
    });

    sliderInitialized = true;
}

/* -------------------------------
   INIT & RELOAD HOOKS
-------------------------------- */
if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function (mutations) {
        let shouldReinitialize = false;

        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
                const addedNodes = Array.from(mutation.addedNodes);
                const hasPriceFilter = addedNodes.some(node => {
                    if (node.nodeType === 1) {
                        return node.querySelector('.facets__price') ||
                            node.classList?.contains('facets__price') ||
                            node.querySelector('.range-slider') ||
                            node.classList?.contains('range-slider');
                    }
                    return false;
                });

                if (hasPriceFilter) {
                    shouldReinitialize = true;
                }
            }
        });

        if (shouldReinitialize) {
            setTimeout(function () {
                sliderInitialized = false;
                initializePriceSlider();
            }, 400);
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
$(document).ready(() => setTimeout(initializePriceSlider, 300));

$(document).on("ajaxComplete", () => {
    sliderInitialized = false;
    setTimeout(initializePriceSlider, 300);
});

let lastUrl = location.href;
setInterval(() => {
    if (lastUrl !== location.href) {
        lastUrl = location.href;
        sliderInitialized = false;
        setTimeout(initializePriceSlider, 300);
    }
}, 300);



let resizeTimeout;
$(window).on("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
        $(".range-slider").each(function () {
            var $slider = $(this);
            var $rangeMin = $slider.find(".rangeMin");
            var $rangeMax = $slider.find(".rangeMax");

            if ($rangeMin.length && $rangeMax.length) {
                // Trigger update for all sliders
                $rangeMin.trigger("input.rangeSlider");
            }
        });
    }, 250);
});



$(window).on('beforeunload', function () {
    // Remove all range slider event handlers
    $('.rangeMin, .rangeMax, .min_value_input, .max_value_input').off('input.rangeSlider');
    $(window).off('resize');
    $(document).off('touchstart touchend', '.rangeMin, .rangeMax');
    sliderInitialized = false;
});



document.querySelectorAll('form').forEach(form => {
  form.addEventListener('submit', function(e) {

    // If reCAPTCHA is not ready, delay submit
    if (window.grecaptcha && !grecaptcha.enterprise) {
      e.preventDefault();
      setTimeout(() => form.submit(), 300);
      return;
    }

    // Normal behavior
    if (!form.checkValidity()) {
      form.reportValidity();
      e.preventDefault();
    }
  });
});









//Discount code on cart page
if($('body').hasClass("cart-template")){
document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#cart-discount-form");
  const input = document.querySelector("#discount-code-input");
  const success = document.querySelector("#discount-code-success");
  const error = document.querySelector("#discount-code-error");

  const hideMessages = () => {
    success.style.display = "none";
    error.style.display = "none";
  };

  const showSuccess = (msg) => {
    success.textContent = msg;
    success.style.display = "block";
  };

  const showError = (msg) => {
    error.textContent = msg;
    error.style.display = "block";
  };


async function refreshCartSections() {
  // Detect real section IDs dynamically
  const itemsId = document.querySelector("[id*='cart-items']")?.id;
  const footerId = document.querySelector("[id*='cart-footer']")?.id;

  if (!itemsId || !footerId) return;

  // Convert to section handles Shopify expects
  const itemsHandle = itemsId.replace("shopify-section-", "");
  const footerHandle = footerId.replace("shopify-section-", "");

  const sectionHandles = [itemsHandle, footerHandle];

  // Map dynamic handles → static container classes
  const sectionTargets = {
    [itemsHandle]: ".custom-cart-items",
    [footerHandle]: ".custom-cart-footer"
  };

  // Fetch updated HTML
  const res = await fetch(`/cart?sections=${sectionHandles.join(",")}`);
  if (!res.ok) return;

  const data = await res.json();

  // Replace DOM sections
  sectionHandles.forEach(handle => {
    const selector = sectionTargets[handle];
    const targetEl = document.querySelector(selector);

    if (targetEl && data[handle]) {
      targetEl.outerHTML = data[handle];
    }
  });
}



  // Apply discount code
  async function applyDiscount(code) {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: code }),
    });

    if (!response.ok) throw new Error("Invalid discount");

    return response.json();
  }

  // Remove applied discount
  async function removeDiscount() {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: "" }),
    });

    if (!response.ok) throw new Error("Failed to remove");

    return response.json();
  }

  // Handle apply
  $(document).on("submit", "#cart-discount-form", async function (e) {
    e.preventDefault();
      const form = e.target.closest("#cart-discount-form");
      const input = form.querySelector("#discount-code-input");

          const $success = $(document).find("#discount-code-success");
          const $error = $(document).find("#discount-code-error");

          // Hide messages
          $success.hide();
          $error.hide();

        const code = input.value.trim();
        
        if (!code) {
          $error.text("Enter a discount code").show();
          return;
        }

        try {
          const cart = await applyDiscount(code);
        const isValid =
          cart.discount_codes &&
          cart.discount_codes.length > 0 &&
          cart.discount_codes.some(
            d => d.code.toLowerCase() === code.toLowerCase() &&
            d.applicable === true
          );

        if (!isValid) {
          $error.text("Invalid discount code").show();
          return;
        }

           // Show success instantly
          $success.text(`Discount "${code}" applied`).show();

          // Clear input
          input.value = "";
        
        // Wait 3 seconds
          setTimeout(async () => {
            await refreshCartSections();  // now rerender cart
          }, 2000);

    


        } catch {
          $error.text("Invalid discount code").show();
        }
  });

  // Delegate remove button (Dawn re-renders DOM → event delegation required)
  document.addEventListener("click", async (e) => {

    if (e.target.matches(".discount-remove-btn")) {

      e.preventDefault();

        const $success = $(document).find("#discount-code-success");
        const $error = $(document).find("#discount-code-error");

      // Hide messages
          $success.hide();
          $error.hide();

      try {
        await removeDiscount();
        // await refreshCartSections();

         $success.text(`Discount has been removed.`).show();
        
        // Wait 3 seconds
          setTimeout(async () => {
            await refreshCartSections();  // now rerender cart
          }, 2000);

        
      } catch {
        $error.text(`Something went wrong!`).show();
        // showError("Failed to remove");
      }
    }
  });
  
});
}



$('.searchIcon').on("click",function(e){
    e.preventDefault();
    $(this).parents('.Search_wrapper').addClass("custom-search-modal-open");
    $('body').addClass('search-overflow-hidden');
    $(".CloseIcon").show();
    $(".searchIcon").hide();
});

$('.CloseIcon').on("click",function(e){
    e.preventDefault();
    $(this).parents('.Search_wrapper').removeClass("custom-search-modal-open");
    $('.custom-form-modal .reset__button ').trigger("click");
    $('body').removeClass('search-overflow-hidden');
    $(".CloseIcon").hide();
    $(".searchIcon").show();
});


//Newsletter code
(function () {
  const POPUP_DELAY = 5000; // 5 seconds
  const MAX_SHOWS_PER_MONTH = 3;

  const popup = document.getElementById('newsletter-popup');
  if (!popup) return;

  const closeBtn = popup.querySelector('.newsletter-popup__close');
  const overlay = popup.querySelector('.newsletter-popup__overlay');

  const storageKey = 'newsletterPopupData';

  function getData() {
    try {
      return JSON.parse(localStorage.getItem(storageKey)) || { count: 0, month: new Date().getMonth() };
    } catch {
      return { count: 0, month: new Date().getMonth() };
    }
  }

  function setData(data) {
    localStorage.setItem(storageKey, JSON.stringify(data));
  }

  function shouldShowPopup() {
    const data = getData();
    const currentMonth = new Date().getMonth();

    if (data.month !== currentMonth) {
      data.count = 0;
      data.month = currentMonth;
      setData(data);
    }

    return data.count < MAX_SHOWS_PER_MONTH;
  }

  function showPopup() {
    const data = getData();
    data.count += 1;
    setData(data);

    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
  }

  function hidePopup() {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
  }

  closeBtn.addEventListener('click', hidePopup);
  overlay.addEventListener('click', hidePopup);

  // Stop showing if user already subscribed
  if (document.body.classList.contains('newsletter-subscribed')) return;

  if (shouldShowPopup()) {
    setTimeout(showPopup, POPUP_DELAY);
  }
})();